import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		marginTop: '16px',
		marginBottom: '16px',
	},
	selectInput: {
		width: '100% !important',
		padding: '6px 8px',
		borderRadius: '4px',
		border: '1px solid #ccc',
		fontSize: '14px',
	},
	fullWidthInput: {
		width: '100% !important',
	},
	permissionsGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		padding: '12px',
		borderRadius: '4px',
		backgroundColor: '#fafafa',
		border: '1px solid #e1e1e1',
	},
	permissionsGroupError: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		padding: '12px',
		borderRadius: '4px',
		backgroundColor: '#fef6f6',
		border: '1px solid #d13438',
	},
	errorMessage: {
		color: '#d13438',
		fontSize: '12px',
		marginTop: '4px',
		display: 'block',
	},
	successContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '40px 20px',
		gap: '16px',
	},
	successIcon: {
		color: '#107c10',
		fontSize: '48px',
	},
	successMessage: {
		fontSize: '16px',
		fontWeight: '600',
		color: '#107c10',
		textAlign: 'center',
	},
});
